<template>
  <div class="history video-list container">
    <div class="columns">
      <div class="column">
        <h1 class="purple">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="39"
            viewBox="0 0 38.9 38.9"
          >
            <!-- eslint-disable-next-line max-len -->
            <path
              class="st0"
              d="M19.4 0C8.7 0 0 8.7 0 19.4c0 10.7 8.7 19.4 19.4 19.4s19.4-8.7 19.4-19.4C38.9 8.7 30.2 0 19.4 0zM19.4 37.4c-9.9 0-18-8.1-18-18 0-9.9 8.1-18 18-18 9.9 0 18 8.1 18 18C37.4 29.4 29.4 37.4 19.4 37.4z"
            />
            <!-- eslint-disable-next-line max-len -->
            <path
              class="st0"
              d="M20.2 15.9V4.3c0-0.4-0.3-0.7-0.7-0.7 -0.4 0-0.7 0.3-0.7 0.7V15.9c-1.4 0.3-2.5 1.4-2.8 2.8H9.4c-0.4 0-0.7 0.3-0.7 0.7 0 0.4 0.3 0.7 0.7 0.7h6.6c0.3 1.6 1.8 2.9 3.5 2.9 2 0 3.6-1.6 3.6-3.6C23 17.7 21.8 16.2 20.2 15.9zM19.4 21.6c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2C21.6 20.6 20.6 21.6 19.4 21.6z"
            />
          </svg>
          צפיות אחרונות
        </h1>
      </div>
    </div>
    <videos :videos="lastVideos"></videos>
  </div>
</template>

<script>
import Videos from "@/components/Videos.vue";

export default {
  name: `HistoryPage`,
  components: {
    Videos,
  },

  computed: {
    lastVideos() {
      const output = [];
      const hist = this.$store.state.user.history;

      if (Array.isArray(this.$store.state.videos)) {
        this.$store.state.videos.forEach(v => {
          const index = hist.indexOf(`${v.id}`);
          if (index > -1) {
            output.splice(index, 0, v);
          }
        });
      }
      return output;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
  },
};
</script>

<style lang="scss">
.history {
  h1 {
    margin: 20px 0;
  }
}
</style>
